var exports = {
  "wt": "MessagePoll.module__poll___WnhTND",
  "aK": "MessagePoll.module__hint___WnhTND",
  "GA": "MessagePoll.module__answers___WnhTND",
  "ZF": "MessagePoll.module__answer___WnhTND",
  "Gh": "MessagePoll.module__answerSelected___WnhTND",
  "M0": "MessagePoll.module__bar___WnhTND",
  "yy": "MessagePoll.module__answerText___WnhTND",
  "sU": "MessagePoll.module__answerStats___WnhTND",
  "qr": "MessagePoll.module__footer___WnhTND",
  "zt": "MessagePoll.module__footerActions___WnhTND",
};

module.exports = exports;
